import search from './furniture/search.js'
import get from './furniture/get.js'
import getInfo from './furniture/get-info.js'
import getData3dStorageId from './furniture/get-data3d-storage-id.js'

var furniture = {
  search: search,
  get: get,
  getInfo: getInfo,
  getData3dStorageId: getData3dStorageId
}

export default furniture